import React, { Component } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import LogoLazada from './logo-lazada.png';

const Container = styled.div`
  font-size: 2.7vw;
  display: flex;
  flex-direction: row;
  height: 10vh;
  background-color: #0d1578;
  color: #ffffff;
  padding: 16px;
  box-sizing: border-box;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  justify-content: space-between;
  align-items: center;
`;

const LeftContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const RightContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;

  & div:first-child {
    margin-right: 45px;
  }
`;

const LogoContainer = styled.div`
  & img {
    height: 8vh;
  }
`;

const Divider = styled.div`
  width: 1px;
  margin-left: 20px;
  margin-right: 20px;
  background-color: #ffffff;
  height: 6vh;
`;

class Header extends Component {
  state = {
    currentTime: '00:00:00',
  };

  componentDidMount() {
    this.getCurrentTime();
  }

  getCurrentTime = () => {
    setInterval(() => {
      this.setState({
        currentTime: moment().format('HH:mm:ss'),
      });
    }, 1000);
  };

  render() {
    return (
      <Container>
        <LeftContainer>
          <LogoContainer>
            <img src={LogoLazada} alt="logo lazada" />
          </LogoContainer>
          <Divider />
          <div>
            รอบ: <strong>{this.props.textRound}</strong>
          </div>
        </LeftContainer>
        <RightContainer>
          <div>
            วันที่รับสินค้า: <strong>{this.props.textPickupDate}</strong>
          </div>
          <div>
            เวลาในขณะนี้: <strong>{this.state.currentTime}</strong>
          </div>
        </RightContainer>
      </Container>
    );
  }
}

export default Header;
